export default {
	appointment: {
		banner_text: 'https://web-data.zmlearn.com/image/tbJ4L9aDjWrJXb2v543K4n/ac_home_banner_text.png',
		button: 'https://web-data.zmlearn.com/image/68bXUWk1rw2rMJXKKhqVWh/ac_btn_home_banner.png',
	},
	classes: {
		title: {
			h1: 'Explorar ',
			span: 'Nuestras Clases',
		},
		titleSuffix: '{prefix} 1 a 1 tutoría',
		list: [
			{
				title: 'Matemáticas',
				img: 'https://web-data.zmlearn.com/image/ksNEH2XHPMGXy2rQjKKeo3/cover_math%402x.png',
				tabs: [
					{
						title: '',
						context: [
							'Private 1-on-1 specialised tutoring',
							'Unique tailored learning plans for each student',
							'Adaptable to your specific tutoring needs',
							`Regular updates on your child's learning progress`,
						],
					},
				],
			},
			{
				title: 'Inglés',
				img: 'https://web-data.zmlearn.com/image/t1DLHLJPc8AgbaiQNpif3B/cover_english%402x.png',
				tabs: [
					{
						title: '',
						context: [
							'Private 1-on-1 specialised tutoring',
							'Unique tailored learning plans for each student',
							'Adaptable to your specific tutoring needs',
							`Regular updates on your child's learning progress`,
						],
					},
				],
			},
			{
				title: 'Chino',
				img: 'https://web-data.zmlearn.com/image/fCd9Z7wu1HqG9DSAgPbhHW/cover_chinese%402x.png',
				tabs: [
					{
						title: '',
						context: [
							'Private 1-on-1 specialised tutoring',
							'Unique tailored learning plans for each student',
							'Adaptable to your specific tutoring needs',
							`Regular updates on your child's learning progress`,
						],
					},
				],
			},
			{
				title: 'Biología',
				img: 'https://web-data.zmlearn.com/image/7agX2UCR9kSPWtnGLz5cDy/cover_biology%402x.png',
				tabs: [
					{
						title: '',
						context: [
							'Private 1-on-1 specialised tutoring',
							'Unique tailored learning plans for each student',
							'Adaptable to your specific tutoring needs',
							`Regular updates on your child's learning progress`,
						],
					},
				],
			},
			{
				title: 'Química',
				img: 'https://web-data.zmlearn.com/image/tTAAyD6Aih7ZAVMg9YaWKV/cover_chemistry%402x.png',
				tabs: [
					{
						title: '',
						context: [
							'Private 1-on-1 specialised tutoring',
							'Unique tailored learning plans for each student',
							'Adaptable to your specific tutoring needs',
							`Regular updates on your child's learning progress`,
						],
					},
				],
			},
			{
				title: 'Física',
				img: 'https://web-data.zmlearn.com/image/uKFPZnNbmLNRLcGW5GSMfp/covere_physics%402x.png',
				tabs: [
					{
						title: '',
						context: [
							'Private 1-on-1 specialised tutoring',
							'Unique tailored learning plans for each student',
							'Adaptable to your specific tutoring needs',
							`Regular updates on your child's learning progress`,
						],
					},
				],
			},
			{
				title: 'Historia',
				img: 'https://web-data.zmlearn.com/image/mbLWb1CAV1zxWxL3RSUd3e/cover_history%402x.png',
				tabs: [
					{
						title: '',
						context: [
							'Private 1-on-1 specialised tutoring',
							'Unique tailored learning plans for each student',
							'Adaptable to your specific tutoring needs',
							`Regular updates on your child's learning progress`,
						],
					},
				],
			},
			{
				title: 'Economía',
				img: 'https://web-data.zmlearn.com/image/hSaWxhcf6jNvVi52s3vtAj/cover_economics%402x.png',
				tabs: [
					{
						title: '',
						context: [
							'Private 1-on-1 specialised tutoring',
							'Unique tailored learning plans for each student',
							'Adaptable to your specific tutoring needs',
							`Regular updates on your child's learning progress`,
						],
					},
				],
			},
			{
				title: 'Geografía',
				img: 'https://web-data.zmlearn.com/image/tE1d96G7h5JMFM5h63bLhm/cover_geography%402x.png',
				tabs: [
					{
						title: '',
						context: [
							'Private 1-on-1 specialised tutoring',
							'Unique tailored learning plans for each student',
							'Adaptable to your specific tutoring needs',
							`Regular updates on your child's learning progress`,
						],
					},
				],
			},
			{
				title: 'Filosofía',
				img: 'https://web-data.zmlearn.com/image/jfkTgam5mszqUVhFLKKzn1/cover_philosophy%402x.png',
				tabs: [
					{
						title: '',
						context: [
							'Private 1-on-1 specialised tutoring',
							'Unique tailored learning plans for each student',
							'Adaptable to your specific tutoring needs',
							`Regular updates on your child's learning progress`,
						],
					},
				],
			},
			{
				title: 'Contabilidad',
				img: 'https://web-data.zmlearn.com/image/cDK7RzvrBcFBwrpAHBGB97/cover_accounting%402x.png',
				tabs: [
					{
						title: '',
						context: [
							'Private 1-on-1 specialised tutoring',
							'Unique tailored learning plans for each student',
							'Adaptable to your specific tutoring needs',
							`Regular updates on your child's learning progress`,
						],
					},
				],
			},
			{
				title: 'Informática',
				img: 'https://web-data.zmlearn.com/image/adC4D7ZvL7gXoBDXAyN9HM/cover_computing%402x.png',
				tabs: [
					{
						title: '',
						context: [
							'Private 1-on-1 specialised tutoring',
							'Unique tailored learning plans for each student',
							'Adaptable to your specific tutoring needs',
							`Regular updates on your child's learning progress`,
						],
					},
				],
			},
			{
				title: 'Ciencia',
				img: 'https://web-data.zmlearn.com/image/7gghuVjMMAgbpJ4KsbZYEm/cover_science%402x.png',
				tabs: [
					{
						title: '',
						context: [
							'Private 1-on-1 specialised tutoring',
							'Unique tailored learning plans for each student',
							'Adaptable to your specific tutoring needs',
							`Regular updates on your child's learning progress`,
						],
					},
				],
			},
			{
				title: 'Derecho',
				img: 'https://web-data.zmlearn.com/image/wZMiYb5hWE2YDj86JV5fqd/cover_law%402x.png',
				tabs: [
					{
						title: '',
						context: [
							'Private 1-on-1 specialised tutoring',
							'Unique tailored learning plans for each student',
							'Adaptable to your specific tutoring needs',
							`Regular updates on your child's learning progress`,
						],
					},
				],
			},
			{
				title: 'Codificación',
				img: 'https://web-data.zmlearn.com/image/25Vn8XLg1mghm2V5h1LGBb/cover_coding%402x.png',
				tabs: [
					{
						title: 'Scratch',
						context: [
							'Private 50min scratch lesssons',
							'Suitable for students over 6 years old',
							'Strengthen logical thinking skills',
							`Understand the basics of programming logic`,
							`Create 30+ fun games and animations`,
						],
					},
					{
						title: 'Phython',
						context: [
							'Private 50min scratch lesssons',
							'Suitable for students over 10 years old',
							'Strengthen logical thinking skills',
							`Understand the basics model of artificial intelligence`,
							`Be able to crawling data, cleaning data, diversification analysis and other steps.`,
						],
					},
				],
			},
			{
				title: 'Música',
				img: 'https://web-data.zmlearn.com/image/w5GuXL67BSDN6zTXqaRxaZ/cover_music%402x.png',
				tabs: [
					{
						title: 'Sing',
						context: [
							'Private 50min singing lesssons',
							'Suitable for students over 4 years old',
							'All our music teachers have degrees from top music colleges and are specialists in their field',
						],
					},
					{
						title: 'Instrument',
						context: [
							'Private 50min scratch lesssons',
							'Suitable for students over 6 years old',
							'All types of instruments including Piano, Classical Guitar, Violin, Cello and so on',
							`Each lesson will be designed to suit your needs, skills, and current level`,
						],
					},
				],
			},
			{
				title: 'Arte',
				img: 'https://web-data.zmlearn.com/image/7uYgmVCiKL2NANfrK4muDk/cover_drawing%402x.png',
				tabs: [
					{
						title: '',
						context: [
							'Private 50min drawing lesssons',
							`Using the concept of “Reggio Emilia approach” in Italy, help children establish perfect imagination and logical thinking ability`,
							`	Suitable for 4-12 years old`,
							`Learn more than 5 popular drawing styles and create own pieces with skills`,
						],
					},
				],
			},
			{
				title: 'Francés',
				img: 'https://web-data.zmlearn.com/image/dpWQ18shkxVh7pQxajLrWB/cover_french%402x.png',
				tabs: [
					{
						title: '',
						context: [
							'Private 1-on-1 specialised tutoring',
							'Unique tailored learning plans for each student',
							'Adaptable to your specific tutoring needs',
							`Regular updates on your child's learning progress`,
						],
					},
				],
			},
			{
				title: 'Español',
				img: 'https://web-data.zmlearn.com/image/4QfjBNjSj6xdtydooQBogu/cover_spanish%402x.png',
				tabs: [
					{
						title: '',
						context: [
							'Private 1-on-1 specialised tutoring',
							'Unique tailored learning plans for each student',
							'Adaptable to your specific tutoring needs',
							`Regular updates on your child's learning progress`,
						],
					},
				],
			},
			{
				title: 'Alemán',
				img: 'https://web-data.zmlearn.com/image/eNNETVLus3kxe3Wfjjwn4U/cover_german%402x.png',
				tabs: [
					{
						title: '',
						context: [
							'Private 1-on-1 specialised tutoring',
							'Unique tailored learning plans for each student',
							'Adaptable to your specific tutoring needs',
							`Regular updates on your child's learning progress`,
						],
					},
				],
			},

			{
				title: 'Italiano',
				img: 'https://web-data.zmlearn.com/image/nFpAuQhwyF5urLFEu26hJp/cover_italian%402x.png',
				tabs: [
					{
						title: '',
						context: [
							'Private 1-on-1 specialised tutoring',
							'Unique tailored learning plans for each student',
							'Adaptable to your specific tutoring needs',
							`Regular updates on your child's learning progress`,
						],
					},
				],
			},
			{
				title: 'Otras asignaturas',
				img: 'https://web-data.zmlearn.com/image/pb4Kn4ErTQRPvLDvPvUpBS/cover_other%402x.png',
				tabs: [
					{
						title: '',
						context: [
							'Private 1-on-1 specialised tutoring',
							'Unique tailored learning plans for each student',
							'Adaptable to your specific tutoring needs',
							`Regular updates on your child's learning progress`,
						],
					},
				],
			},
		],
		buttons: {
			false: 'Desplegar',
			true: 'Guardar',
		},
		viewMore: 'Ver Más',
	},
	classroom: {
		title: `<h1>Aula<span> Virtual</span><p> Divertida</p></h1>`,
		list: [
			{
				id: 1,
				title: 'Tutores experimentados',
				content: 'Un proceso de admisión riguroso y la tasa de aprobación es del 7.8%',
				link: '/:countryCode/tutors',
				backgroundColor: '#FFF',
				icon: 'https://web-data.zmlearn.com/image/3qVZgEFyRFwNp1CZLHqRpq/img_home_part3_circle%402x.png',
				img: [
					'https://web-data.zmlearn.com/image/51wFFJCXPSQCRpfzvFRWTV/img_home_part3_pic1%402x.jpg',
					'https://web-data.zmlearn.com/image/c3oJu6CeY6mJ6fGXna5n8H/img_home_part3_pic1-1.png',
				],
			},
			{
				id: 2,
				title: 'Individual 1:1',
				content: 'Clases a medida que reducir la brecha de aprendizaje',
				link: '/:countryCode/1on1',
				backgroundColor: '#FFF',
				icon: 'https://web-data.zmlearn.com/image/tnhyiJA17Y3BomUBfaQZ66/img_home_part3_cup%402x.png',
				img: [
					'https://web-data.zmlearn.com/image/goQDWg3iS4buDCZMaFRQJK/img_home_part3_pic2%402x.jpg',
					'https://web-data.zmlearn.com/image/8tUe6ZkDBUQtzji1ih1kCL/img_home_part3_pic2m%402x.jpg',
				],
			},
			{
				id: 3,
				title: 'Interactivo en tiempo real',
				content: 'Tenga una conversación fluida de manera natural',
				link: '/:countryCode/1on1',
				backgroundColor: '#FFF',
				icon: 'https://web-data.zmlearn.com/image/2b9k9FmVUDLCwSoGCFg54e/img_home_part_smile%402x.png',
				img: [
					'https://web-data.zmlearn.com/image/fHzqpCRTGe4bZbpXuFdhBu/img_home_part3_pic3%402x.jpg',
					'https://web-data.zmlearn.com/image/wQvEG1rnfJrUzx6gWHpjAK/img_home_part3_pic3m%402x.jpg',
				],
			},
			{
				id: 4,
				title: 'Clases basadas en juegos',
				content: 'Convertir un tema aburrido en un contenido interesante',
				link: '/:countryCode/happy-kids',
				backgroundColor: '#FFF',
				icon: 'https://web-data.zmlearn.com/image/3kPMAL6ADDs7JL2Di6ELnM/img_home_part3_hand%402x.png',
				img: [
					'https://web-data.zmlearn.com/image/u44Su87pev5raK713SgM7H/img_home_part3_pic4%402x.png',
					'https://web-data.zmlearn.com/image/8Jt78iQuKwwh3MEMxSqXD2/img_home_part3_pic4m%402x.png',
				],
			},
		],
	},
	mapCovers: {
		title: {
			h1: 'Estudiantes',
			span: '  de todo el mundo',
		},
		mapImg: 'https://web-data.zmlearn.com/image/uKvKpgDpaKc6bucq5PdMj2/img_home_part4_map.png',
		h4: 'El sistema curricular cubre más de 70 países de todo el mundo',
	},
	rating: {
		title: 'Have to Say About AirClass?',
		titleStrOne: 'What Do&nbsp;',
		titleStrTwo: 'Our Parents ',
		excellent: 'Excellent',
		reviews: 'Based on 2,809 reviews',
		trustpilot: `<!-- TrustBox widget - Review Collector -->
											<div class="trustpilot-widget" data-locale="en-US" data-template-id="56278e9abfbbba0bdcd568bc" data-businessunit-id="61126099553d54001d7abc98" data-style-height="52px" data-style-width="100%"> <a href="https://www.trustpilot.com/review/air-class.com" target="_blank" rel="noopener">Trustpilot</a> </div>
								<!-- End TrustBox widget -->
								`,
		scoreImg: 'https://web-data.zmlearn.com/image/cGm8zZiMaERQXYqqdvhe5E/icon_score.png',
		starts: 'https://web-data.zmlearn.com/image/6WMg3KrGySuGxddwy6wKeR/stars.png',
		list: [
			{
				id: 1,
				name: `Mazzy's mom`,
				title: 'I found this website by chance',
				date: '8 Feb 2022',
				img: 'https://web-data.zmlearn.com/image/oEJzQuFmG8KJx3bSayPzpk/avatar01.png',
				content: `Linda, thank you so much for your support till now. We were so stressed after lockdown about the lack of teaching. We had several trial lesson before we choose AirClass, you're
				more affordable than other we looked at. And Sam is great, thanks again for matching a great tutor for us. Sam encouraged her and built up her confidence over the nine months she was taught by him. She was positive whilst writing her GCSE's and feels good about her performance. `,
			},
			{
				id: 2,
				name: `James's mom`,
				title: 'Happy to choose Airclass',
				date: '9 Jan 2022',
				img: 'https://web-data.zmlearn.com/image/eRRsWaFv6EqbiZ3CYH98dU/avatar02.png',
				content: `James have struggled a lot with A level Chemistry and Biology. I can even feel his stress and have no idea how can l support him. Even at the beginning of tutoring, I was worried about my decison whether it's good for him to have online tutoring,and whether he would feel more stressed. Luckily, I made a good choice, you didn't just teach him, but also a lot of confidence you gave to him. I realy appreciate it. Good job, AirClass.`,
			},
			{
				id: 3,
				name: `Anna`,
				title: 'Ella tutors both of my daughters',
				date: '15 Dec 2021',
				img: 'https://web-data.zmlearn.com/image/pjVKWkR7ecMpNNCoog6voP/avatar03.png',
				content: `Both of our tutors are great. I'd say we really love Harry, he is a patient and experienced tutor. I worried about replacing tutor will effect my daughter's tutoring process as she need to spend time adapting a new tutor again. But harry's lesson time conflicted with ours and I had to apply for another teacher. Sanja is also fantastic, and my daughter loves her tuition as well. `,
			},
		],
		score: 4.8
	},
	school: {
		title: {
			h1: `<h1><p>Escuela en línea </p> n.º 1 <p> mundial</p></h1>`,
		},
		list: [
			{
				id: 1,
				content: `AirClass, fundada en Singapur y el Reino Unido en 2014, es una institución educativa global en línea 1 a 1, que se enfoca en brindar tutoría personalizada para estudiantes de 4 a 18 años de todo el mundo, cubriendo todas tantas las materias académicas, así como Clases especializadas en algunas aficiones.`,
				img: 'https://web-data.zmlearn.com/image/gYYYDmMagkejYbanBUY2DD/img_home_part6_pic1%402x.png',
			},
			{
				id: 2,
				content: `En la actualidad, AirClass es la institución de tutoría individual en línea más grande del mundo con más de 500.000 estudiantes y más de 10.000 tutores experimentados del nivel mundial. Nuestra misión es brindar tutoría de calidad a nuestros estudiantes en cualquier momento y lugar.`,
				img: 'https://web-data.zmlearn.com/image/6sRBgs8HsULNeSsaZ45GLz/img_home_part6_pic2%402x%20(1)%203.png',
			},
			{
				id: 3,
				content: `En 2021, el 91% de los estudiantes encuestados ha mejorado significativamente después de recibir 3 meses de tutoría académica con nosotros. Nuestras nuevas programas de cursos, el curso de inglés NIÑOS FELICES (en inglés: the Happy Kids series) y clases creativas para hobbies o aficiones  (en inglés: the Creative Classes series) , ahora están en línea, que continúan ofreciendo una amplia gama de clases divertidas para niños.`,
				img: 'https://web-data.zmlearn.com/image/gVBuo3CoUmHEA5X6GBNeSm/img_home_part6_pic3%402x.png',
			},
		],
	},
	safeguard: {
		title: {
			h1: '100%',
			span: '  Sin',
			p: ' Riesgos',
		},
		list: [
			{
				id: 1,
				title: 'Control de calidad',
				content: `Todos los tutores han aprobado nuestros procesos de admisión y formación.`,
				backgroundColor: '#FF8395',
				icon: ['#32C095', '#FFC452'],
				img: 'https://web-data.zmlearn.com/image/aTnazj4xbyw5xzJ4iMmQJX/icon_home_part7_pink%402x.png',
			},
			{
				id: 2,
				title: 'Reemplazo del tutor/a',
				content: 'Siempre encontramos un reemplazo (del tutor/a) adecuado en el menor plazo posible.',
				backgroundColor: '#70B2FA',
				icon: ['#FF8395', '#FFC452'],
				img: 'https://web-data.zmlearn.com/image/2YNrSHMR3gY8V7HDczyZcn/icon_home_part7_blue%402x.png',
			},
			{
				id: 3,
				title: 'Pagos y Reembolsos',
				content: 'Todos los métodos de pago comunes están disponibles y posibles reembolsos se harán dentro de los 14 días despues de realizado el pago.',
				backgroundColor: '#2EC89A',
				icon: ['#48B4FF', '#FF8395'],
				img: 'https://web-data.zmlearn.com/image/weC7D4eHds6pH2Dv5E5hE8/icon_home_part7_green%402x.png',
			},
			{
				id: 4,
				title: 'Seguridad',
				content: 'Todos los datos e información personal (vuestros) están 100% seguros con nosotros.',
				backgroundColor: '#FFC452',
				icon: ['#32C095'],
				img: 'https://web-data.zmlearn.com/image/eFdK7FvHvCnGJGkPxj36Rt/icon_home_part7_yellow%402x.png',
			},
		],
	},
	toTop: 'https://web-data.zmlearn.com/image/pQXWWVRRGCc7XTk3JKzsWR/img_home_backtotop%402x.png',
	stress: {
		title: "We're Here to Help You Beat Exam Stress",
		listIcon: 'https://web-data.zmlearn.com/image/o8TdkwH7hS8d32rvU33mEW/img_home_huizhang%402x.png',
		list: [
			'GCSE', 'A-LEVEL', 'AP','7+', '11+', '13+'
		]
	},
};
